import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { CRMEtapaFunil } from 'src/app/models/crm/crmetapa-funil';
import { CRMFiltroOportunidade } from 'src/app/models/crm/crmfiltro-oportunidade';
import { CRMOportunidade } from 'src/app/models/crm/crmoportunidade';

@Injectable({
  providedIn: 'root'
})
export class CrmoportunidadeService {

  constructor(private http: HttpClient) { }

  consultarOportunidades() {
    return this.http.get<CRMOportunidade[]>(globals.apiUrl + '/api/CRMOportunidade/Lista');
  }

  consultarOportunidadesAgrupadasPorEtapas(filtro: CRMFiltroOportunidade) {
    return this.http.post<CRMEtapaFunil[]>(globals.apiUrl + '/api/CRMOportunidade/ListaAgrupadoPorEtapa', filtro);
  }

  consultarOportunidadesComFiltro(filtro: CRMFiltroOportunidade) {
    return this.http.post<CRMOportunidade[]>(globals.apiUrl + '/api/CRMOportunidade/ListaComFiltros', filtro);
  }

  consultarPorIdOportunidade(idOportunidade) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMOportunidade/Buscar',
      { params: new HttpParams().set('id', idOportunidade) });
  }

  salvar(oportunidade: CRMOportunidade) {
    return this.http.post(globals.apiUrl + '/api/CRMOportunidade/Salvar', oportunidade);
  }

  alterarStatus(oportunidade: CRMOportunidade) {
    return this.http.post<any>(globals.apiUrl + '/api/CRMOportunidade/AlterarStatus', oportunidade);
  }

  AlterarStatusEmLote(oportunidades, status, idResposta) {
    return this.http.post<any>(globals.apiUrl + '/api/CRMOportunidade/AlterarStatusEmLote',
      { oportunidades, status, idResposta });
  }

  alterarEtapa(oportunidade: CRMOportunidade) {
    return this.http.post(globals.apiUrl + '/api/CRMOportunidade/AlterarEtapa', oportunidade);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/CRMOportunidade/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  enviarEmailParaContato(idOportunidade, idTemplateEmail) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMOportunidade/EnviarEmailParaContato',
      { params: new HttpParams().set('idOportunidade', idOportunidade).set('idTemplateEmail', idTemplateEmail) });
  }

  trocarUsuario(transferencias) {
    return this.http.post(globals.apiUrl + '/api/CRMOportunidade/TrocarUsuario', transferencias);
  }

  podeEditar(idOportunidade) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMOportunidade/PodeEditar',
      { params: new HttpParams().set('id', idOportunidade) });
  }

  possuiVenda(idOportunidade) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMOportunidade/PossuiVenda',
      { params: new HttpParams().set('id', idOportunidade) });
  }

  listarFilaDeCaptacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao,nomeCliente: string, uf: string, cidade: string, idFunil) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('idFunil', idFunil);

    if (nomeCliente !== null && nomeCliente !== undefined) {
      parametros = parametros.set('nomeCliente', nomeCliente);
    }

    if (uf !== null && uf !== undefined) {
      parametros = parametros.set('uf', uf);
    }

    if (cidade !== null && cidade !== undefined) {
      parametros = parametros.set('cidade', cidade);
    }

    return this.http.get<any>(globals.apiUrl + '/api/CRMOportunidade/ListarFilaDeCaptacao',
      {
        params: parametros
      });
  }

  captarOportunidade(op) {
    return this.http.post(globals.apiUrl + '/api/CRMOportunidade/CaptarOportunidade', op);
  }
}
